import { Button, ButtonVariant } from '@Core/Components'
import { Grid } from '@Core/Components/Grid/Grid'
import { Input } from '@Core/Components/Input/Input'
import { Loader } from '@Core/Components/Loader/Loader'
import { Modal, ModalFooter, ModalSize } from '@Core/Components/Modal/Modal'
import { usePermissions } from '@Core/Hooks/usePermissions'
import { useCreateUser } from '@User/Hooks/useCreateUser/useCreateUser'
import { roles } from '@User/roles'
import { NewUserContent } from './NewUserModal.styles'
import { NewUserModalProps } from './NewUserModal.types'

export const NewUserModal = ({ isOpen, setIsOpen, callback }: NewUserModalProps) => {
    const { handleCreateUser, handleChange, loading } = useCreateUser()
    const { hasPermission } = usePermissions()
    const canGrantException = hasPermission(roles.user.permissions.edit.key)

    const toggleModal = () => {
        setIsOpen(false)
    }

    const { handleSubmit, state } = handleCreateUser(async () => {
        toggleModal()
        await callback?.()
    })

    return (
        <Modal size={ModalSize.Small} isOpen={isOpen} onClose={toggleModal}>
            <form
                onSubmit={(event) => {
                    event.preventDefault()
                    handleSubmit()
                }}
            >
                <h2>Novo Usuário</h2>
                <NewUserContent>
                    {loading && <Loader />}
                    {!loading && (
                        <Grid container>
                            <Grid item lg={12} xs={12}>
                                <Input
                                    useUnform={false}
                                    name="name"
                                    label="Nome"
                                    value={state.name}
                                    onChange={handleChange}
                                />
                            </Grid>
                            <Grid item lg={12} xs={12}>
                                <Input
                                    useUnform={false}
                                    name="mail"
                                    label="E-mail"
                                    type="email"
                                    value={state.mail}
                                    onChange={handleChange}
                                />
                            </Grid>
                            <Grid item lg={12} xs={12}>
                                <small>
                                    O acesso será feito com a conta Microsoft
                                    deste e-mail. Não é preciso definir senha.
                                </small>
                            </Grid>
                            {canGrantException && (
                                <Grid item lg={12} xs={12}>
                                    <details data-testid="password-exception">
                                        <summary className="cursor-pointer text-sm">
                                            Exceção: login com senha
                                        </summary>
                                        <div className="mt-2 grid gap-3">
                                            <label className="flex items-center gap-2 text-sm">
                                                <input
                                                    type="checkbox"
                                                    name="passwordException"
                                                    checked={state.passwordException}
                                                    onChange={handleChange}
                                                />
                                                Permitir login com senha
                                                (sem conta Microsoft)
                                            </label>
                                            {state.passwordException && (
                                                <>
                                                    <Input
                                                        useUnform={false}
                                                        name="exceptionReason"
                                                        label="Motivo da exceção"
                                                        value={state.exceptionReason}
                                                        onChange={handleChange}
                                                    />
                                                    <Input
                                                        useUnform={false}
                                                        name="password"
                                                        label="Senha"
                                                        type="password"
                                                        autoComplete="new-password"
                                                        value={state.password}
                                                        onChange={handleChange}
                                                        helperText="Mínimo de 6 caracteres"
                                                    />
                                                </>
                                            )}
                                        </div>
                                    </details>
                                </Grid>
                            )}
                            <Grid item lg={12} xs={12}>
                                <small>
                                    As permissões poderão ser ajustadas na tela
                                    de detalhes do usuário.
                                </small>
                            </Grid>
                        </Grid>
                    )}
                </NewUserContent>
                <ModalFooter>
                    <Button onClick={toggleModal} variant={ButtonVariant.secondary} type="button">
                        Cancelar
                    </Button>
                    <Button type="submit" variant={ButtonVariant.primary} disabled={loading}>
                        Cadastrar
                    </Button>
                </ModalFooter>
            </form>
        </Modal>
    )
}